// extracted by mini-css-extract-plugin
module.exports = {"container":"twocolumn_container__svVeY","link":"twocolumn_link__xug9I","wrapper":"twocolumn_wrapper___YLl_","left":"twocolumn_left__Zfq78","right":"twocolumn_right__Zt037"};